module.exports = __webpack_public_path__ + "static/img/back.acfeb580.jpg";